import React, { FC, useCallback, useMemo, useState } from 'react'
import { DashboardLayoutProps } from './Layout1'
import DeleteWidget from '../delete-widget/DeleteWidget'
import ListWidget from 'components/molecules/widgets/medium/ListWidget'
import EmptyWidget from '../empty-widget/EmptyWidget'
import AddWidgets from '../add-widgets/AddWidgets'
import TopSourceWidget from 'components/molecules/widgets/medium/TopSourceWidget'
import BarChartWidget from 'components/molecules/widgets/medium/BarChartWidget'
import DoubleBarWidget from 'components/molecules/widgets/medium/DoubleBarWidget'
import ReminderWidget from 'components/molecules/widgets/medium/ReminderWidget'
import StatisticChartWidget from 'components/molecules/widgets/medium/StatisticChartWidget'
import LeaderBoardWidget from 'components/molecules/widgets/large/LeaderBoardWidget'
import CounterTool from 'components/molecules/counter-tool/CounterTool'



const Layout2: FC<DashboardLayoutProps> = ({ data, isEditing, setModalData }) => {

    const [AddWidgetModalData, setAddWidgetModalData] = useState<any>(null)

    const widgets = useMemo(() => {

        return data?.widgets
    }, [data])


    const getWidgetFromPosition = useCallback(
        (position: number) => {
            return widgets?.find((widget: any) => widget.position === position)
        },
        [widgets]
    );

    return (
        <div className={`grid grid-rows-2 grid-cols-4 min-h-screen gap-5`}>
            <div className=" col-span-4 sm:col-span-2 2xl:col-span-3 row-span-1 flex relative max-h-[450px]">
                {widgets && getWidgetFromPosition(1) ? (
                    <>
                        <DeleteWidget isEditing={isEditing} data={{ id: data.id, widget_id: getWidgetFromPosition(1).widget_id, position: 1 }} />
                        {
                            (getWidgetFromPosition(1).widget_name === 'Appointments Converted To Customer' ||
                                getWidgetFromPosition(1).widget_name === 'Customer Pendings Done On Periods'
                            ) ? (

                                <DoubleBarWidget
                                    api={getWidgetFromPosition(1).api_endpoint}
                                    name={getWidgetFromPosition(1).widget_name}
                                    type={getWidgetFromPosition(1).type}
                                />


                            ) : (
                                (getWidgetFromPosition(1).type === 'Statistics') ? (
                                    getWidgetFromPosition(1).widget_name === 'Customer Counter Tool' ? (
                                        <CounterTool />
                                    ) : (

                                        <StatisticChartWidget
                                            api={getWidgetFromPosition(1).api_endpoint}
                                            name={getWidgetFromPosition(1).widget_name}
                                            type={getWidgetFromPosition(1).type}
                                        />
                                    )


                                ) : (
                                    <ListWidget
                                        api={getWidgetFromPosition(1).api_endpoint}
                                        name={getWidgetFromPosition(1).widget_name}
                                        setModalData={setModalData}
                                    />
                                )
                            )
                        }

                    </>
                ) : (
                    <EmptyWidget
                        setAddWidgetModalData={setAddWidgetModalData}
                        data={{ id: data.id, position: 1, size: '75x25' }}
                    />
                )}
            </div>
            <div className="col-span-4 sm:col-span-2 2xl:col-span-1 row-span-1 flex relative max-h-[450px]">
                {widgets && getWidgetFromPosition(2) ? (
                    <>
                        <DeleteWidget isEditing={isEditing} data={{ id: data.id, widget_id: getWidgetFromPosition(2).widget_id, position: 2 }} />

                        {
                            (
                                getWidgetFromPosition(2).widget_name === 'Top Sources By Leads' ||
                                getWidgetFromPosition(2).widget_name === 'Top Sources By Appointments'
                            ) && (
                                <TopSourceWidget
                                    api={getWidgetFromPosition(2).api_endpoint}
                                    name={getWidgetFromPosition(2).widget_name}
                                    type={getWidgetFromPosition(2).type}
                                />
                            )
                        }
                        {
                            (getWidgetFromPosition(2).widget_name === 'Leads Created On Periods' ||
                                getWidgetFromPosition(2).widget_name === 'Appointments Created On Periods' ||
                                getWidgetFromPosition(2).widget_name === 'Customers Created On Periods' ||
                                getWidgetFromPosition(2).widget_name === 'Customer Pendings Created On Periods'
                            ) && (
                                <BarChartWidget
                                    api={getWidgetFromPosition(2).api_endpoint}
                                    name={getWidgetFromPosition(2).widget_name}
                                    type={getWidgetFromPosition(2).type}
                                />
                            )
                        }
                        {
                            (getWidgetFromPosition(2).widget_name === 'Customers Birthday Reminder' ||
                                getWidgetFromPosition(2).widget_name === 'Customer Pendings Reminder'
                            ) && (
                                <ReminderWidget
                                    api={getWidgetFromPosition(2).api_endpoint}
                                    name={getWidgetFromPosition(2).widget_name}
                                    type={getWidgetFromPosition(2).type}
                                />
                            )
                        }
                        {(getWidgetFromPosition(2).widget_name === 'Leaderboard') && (
                            <LeaderBoardWidget
                                name={getWidgetFromPosition(2).widget_name}
                                api={getWidgetFromPosition(2).api_endpoint}
                                type={getWidgetFromPosition(2).type}
                            />
                        )}
                    </>
                ) : (
                    <EmptyWidget
                        setAddWidgetModalData={setAddWidgetModalData}
                        data={{ id: data.id, position: 2, size: '25x50' }}
                    />
                )}
            </div>
            <div className="col-span-4 sm:col-span-2 2xl:col-span-3 row-span-1 flex relative max-h-[450px]">
                {widgets && getWidgetFromPosition(3) ? (
                    <>
                        <DeleteWidget isEditing={isEditing} data={{ id: data.id, widget_id: getWidgetFromPosition(3).widget_id, position: 3 }} />
                        {
                            (getWidgetFromPosition(3).widget_name === 'Appointments Converted To Customer' ||
                                getWidgetFromPosition(3).widget_name === 'Customer Pendings Done On Periods'
                            ) ? (

                                <DoubleBarWidget
                                    api={getWidgetFromPosition(3).api_endpoint}
                                    name={getWidgetFromPosition(3).widget_name}
                                    type={getWidgetFromPosition(3).type}
                                />


                            ) : (
                                (getWidgetFromPosition(3).type === 'Statistics') ? (
                                    getWidgetFromPosition(3).widget_name === 'Customer Counter Tool' ? (
                                        <CounterTool />
                                    ) : (

                                        <StatisticChartWidget
                                            api={getWidgetFromPosition(3).api_endpoint}
                                            name={getWidgetFromPosition(3).widget_name}
                                            type={getWidgetFromPosition(3).type}
                                        />
                                    )


                                ) : (
                                    <ListWidget
                                        api={getWidgetFromPosition(3).api_endpoint}
                                        name={getWidgetFromPosition(3).widget_name}
                                        setModalData={setModalData}
                                    />
                                )
                            )
                        }

                    </>
                ) : (
                    <EmptyWidget
                        setAddWidgetModalData={setAddWidgetModalData}
                        data={{ id: data.id, position: 3, size: '75x25' }}
                    />
                )}
            </div>
            <div className="col-span-4 sm:col-span-2 2xl:col-span-1 row-span-1 flex relative max-h-[450px]">
                {widgets && getWidgetFromPosition(4) ? (
                    <>
                        <DeleteWidget isEditing={isEditing} data={{ id: data.id, widget_id: getWidgetFromPosition(4).widget_id, position: 4 }} />

                        {
                            (
                                getWidgetFromPosition(4).widget_name === 'Top Sources By Leads' ||
                                getWidgetFromPosition(4).widget_name === 'Top Sources By Appointments'
                            ) && (
                                <TopSourceWidget
                                    api={getWidgetFromPosition(4).api_endpoint}
                                    name={getWidgetFromPosition(4).widget_name}
                                    type={getWidgetFromPosition(4).type}
                                />
                            )
                        }
                        {
                            (getWidgetFromPosition(4).widget_name === 'Leads Created On Periods' ||
                                getWidgetFromPosition(4).widget_name === 'Appointments Created On Periods' ||
                                getWidgetFromPosition(4).widget_name === 'Customers Created On Periods' ||
                                getWidgetFromPosition(4).widget_name === 'Customer Pendings Created On Periods'
                            ) && (
                                <BarChartWidget
                                    api={getWidgetFromPosition(4).api_endpoint}
                                    name={getWidgetFromPosition(4).widget_name}
                                    type={getWidgetFromPosition(4).type}
                                />
                            )
                        }
                        {
                            (getWidgetFromPosition(4).widget_name === 'Customers Birthday Reminder' ||
                                getWidgetFromPosition(4).widget_name === 'Customer Pendings Reminder'
                            ) && (
                                <ReminderWidget
                                    api={getWidgetFromPosition(4).api_endpoint}
                                    name={getWidgetFromPosition(4).widget_name}
                                    type={getWidgetFromPosition(4).type}
                                />
                            )
                        }
                        {(getWidgetFromPosition(4).widget_name === 'Leaderboard') && (
                            <LeaderBoardWidget
                                name={getWidgetFromPosition(4).widget_name}
                                api={getWidgetFromPosition(4).api_endpoint}
                                type={getWidgetFromPosition(4).type}
                            />
                        )}
                    </>
                ) : (
                    <EmptyWidget
                        setAddWidgetModalData={setAddWidgetModalData}
                        data={{ id: data.id, position: 4, size: '25x50' }}
                    />
                )}
            </div>
            <AddWidgets
                data={AddWidgetModalData}
                hocisOpen={AddWidgetModalData !== null}
                hocToggleModal={() => setAddWidgetModalData(null)}
                hocCurrentStep={1}
                hocClasses={{
                    modalClassName: `sm:max-w-[900px] sm:w-full w-full `,
                }}
                hocTitle="Dashboard"
                onConfirm={() => setAddWidgetModalData(null)}
            />
        </div>
    )
}

export default Layout2